// Otis Admin PRO React example components
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";

function LandingLayout() {
  const navigate = useNavigate();

  const handleOpen = () => {
    navigate("/trafficmonitoring/monitoring");
  };

    return (
        <div style={{ padding: "30px" }}>
            <Card>
                <MDBox p={3} lineHeight={1} textAlign="center">
                    <MDTypography variant="h1" fontWeight="medium">
                        Athens Toolbox
                    </MDTypography>
                    <MDBox mt={2} mb={4} display="flex" justifyContent="center">
                      <MDTypography variant="body1" color="text" sx={{ maxWidth: "700px" }}>
                        A traffic monitoring and analytics platform for the Athens Living Lab,
                        integrating real-time and historical traffic monitoring, route flow
                        analysis, and event management into a single toolbox
                      </MDTypography>
                    </MDBox>
                    <MDButton variant="contained" color="info" onClick={handleOpen}>
                      Enter Toolbox
                    </MDButton>
                </MDBox>
            </Card>
        </div>
    );
}

export default LandingLayout;